
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { PosterItem } from "@/data/postersData";
import api from "@/network/api";

interface PosterDetails extends PosterItem {
  description?: string;
}

@Component
export default class PosterModal extends Vue {
  @Prop({ type: Number, default: null }) posterId!: number | null;
  @Prop({ type: Object, default: null }) posterData!: PosterItem | null;

  private visible = false;
  private loading = false;
  private imageLoading = false;
  private error: string | null = null;
  private posterDetails: PosterDetails | null = null;

  @Watch("posterId")
  onPosterIdChange(newId: number | null) {
    if (newId !== null) {
      this.open();
    }
  }

  open() {
    this.visible = true;
    this.fetchPosterDetails();
  }

  async fetchPosterDetails() {
    if (!this.posterId && !this.posterData) {
      this.error = "No poster selected";
      return;
    }

    this.loading = true;
    this.imageLoading = true;
    this.error = null;

    try {
      if (this.posterData) {
        this.posterDetails = {
          ...this.posterData,

        };
      }

      // Fetch additional details from API if needed
      // if (this.posterId) {
      //   const response = await api.get(`posters/${this.posterId}`);
      //   if (response.data) {
      //     this.posterDetails = {
      //       ...this.posterDetails,
      //       ...response.data
      //     };
      //   }
      // }
    } catch (err: any) {
      // If API fails, still show the basic poster data
      if (this.posterData) {
        this.posterDetails = {
          ...this.posterData,
        };
      } else {
        this.error = err?.message || "Failed to load poster details";
      }
    } finally {
      this.loading = false;
    }
  }

  onImageLoad() {
    this.imageLoading = false;
  }

  @Emit("close")
  close() {
    this.visible = false;
    this.posterDetails = null;
    this.imageLoading = false;
    this.error = null;
    return false;
  }

  public setVisible(isVisible: boolean) {
    this.visible = isVisible;
    if (isVisible) {
      this.fetchPosterDetails();
    }
  }
}
